import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import {
  BaseProfileFieldsFragment,
  EventFieldsFragment
} from 'graphql/generated'
import Thumbnail from 'components/Thumbnail'
import RoundedIconButton from 'components/common/RoundedIconButton'
import Button from 'components/Button'
import { Typography } from 'components/common'
import ModalTrigger from 'components/common/ModalTrigger'
import { UserModal } from 'components/profiles/UserModal'

interface IProps {
  user: BaseProfileFieldsFragment
  event: EventFieldsFragment
  roundButton?: boolean
}

export const EventUser: React.FC<IProps> = ({
  user,
  roundButton = false
}: IProps) => {
  return (
    <div className="flex items-center mt-2 pb-4 justify-between">
      <div className="flex items-center">
        <Thumbnail
          src={user.thumb}
          className="h-12 w-12 rounded-full overflow-hidden"
        />
        <div className="ml-2">
          <Typography>{user.displayName}</Typography>
        </div>
      </div>

      <div>
        <ModalTrigger
          trigger={open =>
            roundButton ? (
              <RoundedIconButton
                data-testid={`user_modal_${user.id}`}
                icon={faInfoCircle}
                onClick={open}
                size="xs"
                color="lightGray"
              />
            ) : (
              <Button
                data-testid={`user_modal_${user.id}`}
                label="View Profile"
                icon={faInfoCircle}
                color="white"
                rounded="lg"
                size="xs"
                labelClassName="text-gray-500"
                onClick={open}
              />
            )
          }
        >
          <UserModal userId={user.id} />
        </ModalTrigger>
      </div>
    </div>
  )
}
